import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalHapus extends React.Component {

    render() {
        const { saveHandler, Model, ShowModalDel, cancelHandler } = this.props

        return (

            <div class="mb-10">

                <Modal show={ShowModalDel} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Hapus</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/sent.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p>Anda yakin ingin menghapus relasi '{Model.name}' ?</p>
                        </div>

                        
                        {/* <h5>Anda yakin ingin menghapus data {Model.name}?</h5> */}
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        <button class="btn btn-danger" onClick={() => saveHandler()}>Yakin</button>
                    </Modal.Footer>
                </Modal>            </div>
        )
    }
}
